import { Row } from "antd";
import { ReactNode, useMemo } from "react";
import { transformToFloat } from "../../../../../../../lib/transformToFloat";
import { EditOutlined } from "@ant-design/icons";
import { getFormattedCurrency } from "../../../../../../../lib/currencyFormatter";

type BeforeAfterCellProps = {
  name: string;
  instance: any;
  isPaymentPosted: boolean;
  isHistoryOpened: boolean;
  openInterestPopup?: () => void;
};

export const BeforeAfterCell = ({
  name,
  instance,
  isPaymentPosted,
  isHistoryOpened,
  openInterestPopup,
}: BeforeAfterCellProps) => {
  const before: number = useMemo(
    () => transformToFloat(instance.breakdown[`${name}Before`]) || 0,
    [name, instance],
  );

  const after: number = useMemo(
    () => transformToFloat(instance.breakdown[`${name}After`]) || 0,
    [name, instance],
  );

  const isBeforeError: boolean = useMemo(
    () => (name === "lateCharge" ? !!before : before < 0),
    [before, name],
  );

  const isAfterError: boolean = useMemo(
    () => (name === "lateCharge" ? !!after : after < 0),
    [after, name],
  );

  const afterNode: ReactNode = useMemo(() => {
    const className: string = `my-0 text-sm elipsis ${
      isAfterError ? "error" : ""
    }`;

    return <p className={className}>{getFormattedCurrency(after)}</p>;
  }, [after, isAfterError]);

  return (
    <Row className="w-100">
      <Row className="justify-end w-100 before-after-cell">
        <p className={`my-0 text-sm elipsis ${isBeforeError ? "error" : ""}`}>
          {getFormattedCurrency(before)}
        </p>
        {name === "interest" && !isPaymentPosted && !isHistoryOpened ? (
          <Row
            className="interest-after w-100 justify-space-between logo-cursor"
            onClick={openInterestPopup}
          >
            <EditOutlined className="text-md title" />
            {afterNode}
          </Row>
        ) : (
          afterNode
        )}
      </Row>
    </Row>
  );
};
